import {mapActions, mapGetters} from "vuex";
import CartItem from "components/mini-shopping-carts/CartItem";

export default {
    components: {
        CartItem,
    },
    data() {
        return {
            showCart: false,
        }
    },
    computed: {
        ...mapGetters("cart", ["getCartState", "getCartItems"]),
        subtotal() {
            return (this.$storeInfo.cur_symb || '$') + this.getCartState.subtotal;
        }
    },
    mounted() {
        console.log('MiniShoppingCart Component Mounted')
    },
    methods: {
        ...mapActions("cart", ["setCartItems"]),
        toggleMiniCart() {
            this.showCart = !this.showCart;
        }
    }
}
